import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import mosadsAPI from '../../utils/api/mosads';

export const fetchMosads = createAsyncThunk(
  'mosads/fetchMosads',
  async (_, { rejectWithValue }) => {
    try {
      const response = await mosadsAPI.getAllMosads();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createMosad = createAsyncThunk(
  'mosads/createMosad',
  async (mosadData, { rejectWithValue }) => {
    try {
      const response = await mosadsAPI.create(mosadData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateMosad = createAsyncThunk(
  'mosads/updateMosad',
  async ({ id, mosadData }, { rejectWithValue }) => {
    try {
      const response = await mosadsAPI.update(id, mosadData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteMosad = createAsyncThunk(
  'mosads/deleteMosad',
  async (id, { rejectWithValue }) => {
    try {
      await mosadsAPI.delete(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  mosadsList: [],
  loading: false,
  error: null
};

const mosadsSlice = createSlice({
  name: 'mosads',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearMosadsState: (state) => {
      state.mosadsList = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Mosads
      .addCase(fetchMosads.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMosads.fulfilled, (state, action) => {
        state.loading = false;
        state.mosadsList = action.payload.data;
      })
      .addCase(fetchMosads.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Mosad
      .addCase(createMosad.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMosad.fulfilled, (state, action) => {
        state.loading = false;
        state.mosadsList.push(action.payload);
      })
      .addCase(createMosad.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Mosad
      .addCase(updateMosad.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMosad.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.mosadsList.findIndex(mosad => mosad.id === action.payload.id);
        if (index !== -1) {
          state.mosadsList[index] = action.payload;
        }
      })
      .addCase(updateMosad.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Mosad
      .addCase(deleteMosad.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMosad.fulfilled, (state, action) => {
        state.loading = false;
        state.mosadsList = state.mosadsList.filter(mosad => mosad.id !== action.payload);
      })
      .addCase(deleteMosad.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError, clearMosadsState } = mosadsSlice.actions;
export default mosadsSlice.reducer; 